import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserAuth } from "./authContext";

const PrivateRoutes = () => {
    const { user } = UserAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                console.log('Checking authentication status...');

                // Retrieve user info from local storage
                const storedUser = JSON.parse(localStorage.getItem('user'));

                // Check if the user exists in local storage or context
                if (storedUser || user) {
                    setIsAuthenticated(true);
                    console.log('User:', storedUser || user);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error('Error checking authentication:', error);
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);
            }
        };

        // Run authentication check
        checkAuthentication();
    }, [user]);

    if (isLoading) {
        return <div className="loading-spinner">Loading...</div>; // Placeholder for loading state
    }

    // If user is authenticated, render the outlet; otherwise, redirect to login
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
